import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrReportGroupBy.ts
var t = () => e("reportGroupBy");
//#endregion
export { t as useTrReportGroupBy };
